import { useState } from 'react';
import { Box, Portal, useDisclosure } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import { Redirect, Switch } from 'react-router-dom';

import Footer from 'components/footer/FooterAdmin';
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';
import { currentRoleSelector, GetUsersInfo } from 'data/selectors';
import 'mapbox-gl/dist/mapbox-gl.css';
import { manager } from 'routes';
import {getActiveRoute, getRoute, getActiveNavbar, getRouteForRole} from "../utils";


export default function DashboardManager(props: { [x: string]: any }) {
  const { ...rest } = props;
  const user: any = useRecoilValue(GetUsersInfo);
  const role = useRecoilValue(currentRoleSelector);
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);

  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  return (
    <Box display={'flex'}>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar
        }}
      >
        <Sidebar routes={manager} {...rest} />
        <Box
          float="right"
          minH="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
          maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText={'Horizon UI Dashboard PRO'}
                brandText={getActiveRoute(manager)}
                secondary={getActiveNavbar(manager)}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute(role) ? (
            <Box
              mx="auto"
              p={{ base: '20px', md: '30px' }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Switch>
                {getRouteForRole(manager, role)}
                <Redirect from="/" to={`/${role}/dashboard`} />
              </Switch>
            </Box>
          ) : null}
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
